module.exports = __webpack_public_path__ + "static/media/ils_digilocker_success.6551a23e.svg";